import React, { useCallback, useMemo } from 'react';
import { Typography, Button, Flex, Grid } from 'antd';
import { LeftOutlined } from 'src/components';

import styled from 'styled-components';
import Countdown from 'src/components/Countdown/Countdown';
import { useSelector } from 'react-redux';
import { blockedUntilSelector } from 'src/store/sessions';
import { getCountdownDuration } from 'src/utils/date';

const { Title, Text } = Typography;
const { useBreakpoint } = Grid;

const TitleWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const LeftOutlinedStyled = styled(LeftOutlined)`
  color: ${(props) => props.theme.antd.colorTextSecondary};
  margin-right: 10px;
`;

const DescriptionWrapper = styled.div<{ isMobile?: boolean }>`
  display: flex;
  margin-bottom: 40px;
  text-align: ${(props) => (props.isMobile ? 'center' : '')};
`;

const CountdownContainer = styled.div<{ isMobile?: boolean }>`
  display: flex;
  justify-content: center;
`;

const ButtonContainer = styled(Flex)`
  padding-top: 32px;
`;

interface IProps {
  onClick: () => void;
  error: string | null;
}

// Longest block for a few wrong codes in a row; a longer one is the 1-hour block for wrong codes within an hour
const SHORT_BLOCK_DURATION = 60 * 5;

export const TimerForm: React.FC<IProps> = (props) => {
  const { onClick, error } = props;

  const screen = useBreakpoint();
  const blockedUntil = useSelector(blockedUntilSelector);
  const countdownDuration = useMemo(() => getCountdownDuration(blockedUntil ?? 0), [blockedUntil]);
  const isLongBlock = countdownDuration > SHORT_BLOCK_DURATION;

  const handleOnComplete = useCallback(() => {
    onClick();
  }, [onClick]);

  return (
    <div data-testid="TimerForm">
      <TitleWrapper>
        <Title level={5}>
          <LeftOutlinedStyled />
          Введіть код доступу
        </Title>
      </TitleWrapper>
      <DescriptionWrapper isMobile={!screen.sm}>
        {isLongBlock ? (
          <Text type="secondary" data-testid="description">
            Шановний співробітник. На жаль, Ваш обліковий запис заблоковано на 60 хвилин.
            <br />
            <br />
            Будь ласка, спробуйте авторизуватися через 60 хвилин та будьте уважні, коли будете
            вводити код.
          </Text>
        ) : (
          <Text type="secondary" data-testid="description">
            Шановний співробітник. На жаль, Ви кілька разів невірно ввели код доступу, тому Ваш
            обліковий запис тимчасово заблоковано.
            <br />
            <br />
            Будь ласка, спробуйте авторизуватись, коли завершиться відлік часу, та будьте уважні, коли
            будете вводити код доступу
          </Text>
        )}
      </DescriptionWrapper>
      <CountdownContainer>
        <Countdown countdownDuration={countdownDuration} onComplete={handleOnComplete} />
      </CountdownContainer>
      <ButtonContainer>
        <Button size="large" block onClick={handleOnComplete}>
          Повернутись на головну
        </Button>
      </ButtonContainer>
    </div>
  );
};
